export default __webpack_public_path__ + "static/media/bliss.f8d6e907.jpg";